module.exports = __webpack_public_path__ + "img/Ident-3.69af2602.png";